import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/floorMap.png'


const _withScopeId = n => (_pushScopeId("data-v-0a9ecc8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "schedule-map" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_2 = { class: "schedule-table permanent" }
const _hoisted_3 = { class: "schedule-wrap" }
const _hoisted_4 = { class: "schedule-day day-1" }
const _hoisted_5 = { class: "schedule-table day-1" }
const _hoisted_6 = { class: "schedule-day day-2" }
const _hoisted_7 = { class: "schedule-table day-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_ScheduleBox = _resolveComponent("ScheduleBox")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-schedule" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('h2_1')), 1)
            ]),
            _: 1
          }),
          _hoisted_1,
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('permanent', 'h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ScheduleBox, {
              title: _ctx.$props.i18n.$text('permanent', 'event_1', 'title'),
              id: "avatar_dressing_room"
            }, null, 8, ["title"]),
            _createVNode(_component_ScheduleBox, {
              title: _ctx.$props.i18n.$text('permanent', 'event_2', 'title'),
              id: "poster_exhibition"
            }, null, 8, ["title"])
          ]),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$props.i18n.$text('timetable', 'h2_1')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$props.i18n.$text('timetable', 'day_1')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_1', 'title'),
                day: 1,
                time: _ctx.$props.i18n.$text('timetable', 'event_1', 'time'),
                id: "opening"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_2', 'title'),
                day: 1,
                time: _ctx.$props.i18n.$text('timetable', 'event_2', 'time'),
                id: "whiteboard_1"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_3', 'title'),
                day: 1,
                time: _ctx.$props.i18n.$text('timetable', 'event_3', 'time'),
                id: "group_photo"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_4', 'title'),
                day: 1,
                time: _ctx.$props.i18n.$text('timetable', 'event_4', 'time'),
                id: "jmof_rock_festival"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_5', 'title'),
                day: 1,
                time: _ctx.$props.i18n.$text('timetable', 'event_5', 'time'),
                id: "whiteboard_2"
              }, null, 8, ["title", "time"])
            ]),
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$props.i18n.$text('timetable', 'day_2')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_7', 'title'),
                day: 2,
                time: _ctx.$props.i18n.$text('timetable', 'event_7', 'time'),
                id: "radio_exercises"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_8', 'title'),
                day: 2,
                time: _ctx.$props.i18n.$text('timetable', 'event_8', 'time'),
                id: "vr_experience"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_9', 'title'),
                day: 2,
                time: _ctx.$props.i18n.$text('timetable', 'event_9', 'time'),
                id: "furries_research"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_10', 'title'),
                day: 2,
                time: _ctx.$props.i18n.$text('timetable', 'event_10', 'time'),
                id: "whiteboard_3"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_11', 'title'),
                day: 2,
                time: _ctx.$props.i18n.$text('timetable', 'event_11', 'time'),
                id: "ending"
              }, null, 8, ["title", "time"]),
              _createVNode(_component_ScheduleBox, {
                title: _ctx.$props.i18n.$text('timetable', 'event_12', 'title'),
                day: 2,
                time: _ctx.$props.i18n.$text('timetable', 'event_12', 'time'),
                id: "dead_dog_party"
              }, null, 8, ["title", "time"])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}